import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_signature_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_website: fromDatatype.GuidDataFieldInterface;
  signature_option: fromDatatype.JsonDatatypeInterface;
  signature_public_key: fromDatatype.TextDatatypeInterface;
  signature_output: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_generic_doc_signature_RowClass
  implements bl_fi_generic_doc_signature_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_website: fromDatatype.GuidDataFieldInterface;
  signature_option: fromDatatype.JsonDatatypeInterface;
  signature_public_key: fromDatatype.TextDatatypeInterface;
  signature_output: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
